import React, { useMemo } from 'react';
import { TPriceStrategy } from 'types';
import { priceStrategies } from 'appConstants/dishes';
import { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';
import FormSelect from 'components/Select/FormSelect';
import { ISelectOption } from 'components/Select/types';

interface IProps {
	changePriceStrategy: (value: TPriceStrategy) => void;
	isDisabled: boolean;
}

export const PriceStrategySelect: React.FC<IProps> = React.memo(({ changePriceStrategy, isDisabled }) => {
	const { t } = useTranslation('error');
	const { t: tForm } = useTranslation('form');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('selectPriceStrategy') }], [t]);

	const mappedOptions = useMemo<ISelectOption[]>(
		() =>
			priceStrategies.map((strategy) => ({
				id: strategy.id,
				name: tForm(strategy.name),
				disabled: strategy.disabled,
			})),
		[tForm],
	);

	return (
		<FormSelect
			testId="PriceStrategySelect"
			name="priceStrategy"
			label="priceStrategyLabel"
			options={mappedOptions}
			validationRules={validationRules}
			withSearch={false}
			allowClear={false}
			disabled={isDisabled}
			onChange={changePriceStrategy}
		/>
	);
});
